import { render, staticRenderFns } from "./QuotesListFilters.vue?vue&type=template&id=2437a209&"
import script from "./QuotesListFilters.vue?vue&type=script&lang=js&"
export * from "./QuotesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./QuotesListFilters.vue?vue&type=style&index=0&id=2437a209&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports